const REGISTRATION_AUTH_COMPLETE_SESSION_KEY = 'registration-auth-complete-session';
const REGISTRATION_AUTH_COMPLETE_URL_PARAM = 'registration-auth-complete';

function setRegistrationAuthComplete(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(REGISTRATION_AUTH_COMPLETE_SESSION_KEY, 'true');
}

function hasRegistrationAuthSessionFlag(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return sessionStorage.getItem(REGISTRATION_AUTH_COMPLETE_SESSION_KEY) === 'true';
}

function isRegistrationAuthReturnUrl(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return new URLSearchParams(window.location.search).get(REGISTRATION_AUTH_COMPLETE_URL_PARAM) === 'true';
}

function isRegistrationAuthComplete(): boolean {
  return hasRegistrationAuthSessionFlag() || isRegistrationAuthReturnUrl();
}

function clearRegistrationAuthComplete(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(REGISTRATION_AUTH_COMPLETE_SESSION_KEY);
}

export { clearRegistrationAuthComplete, hasRegistrationAuthSessionFlag, isRegistrationAuthComplete, isRegistrationAuthReturnUrl, setRegistrationAuthComplete };
